import classnames from 'classnames/bind'
import React, { useState } from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import ImageWithPlaceHolder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'
import { ReactComponent as PlayIcon } from '~/components/VideoPlayer/icons/play.svg'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BoxColumnImageTextProps {
  className?: string
  reversed?: boolean
  horizontal?: boolean
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
  image?: ImageWithPlaceholderProps
  video?: string
}

function BoxColumnImageText({
  className,
  reversed,
  horizontal,
  title,
  text,
  primaryCta,
  secondaryCta,
  image,
  video,
}: BoxColumnImageTextProps) {
  const titleStyle = useStyle({
    textPreset: 'title-section',
  })
  const textStyle = useStyle({
    textPreset: 'rich-text-variant-1',
    color: 'cornflower-blue',
  })

  let asset

  const [playing, setPlaying] = useState(false)

  if (video) {
    asset = (
      <div className={css.asset}>
        {image && !playing && (
          <ImageWithPlaceHolder
            className={css.image}
            layout="fill"
            objectFit="cover"
            onClick={() => setPlaying(true)}
            {...image}
          />
        )}
        {!playing && (
          <div className={css.playIcon}>
            <PlayIcon />
          </div>
        )}
        {video && playing && (
          <iframe
            className={css.iframe}
            src={`${video}?autoplay=1&autopause=0&title=0&byline=0&portrait=0`}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            frameBorder={0}
          />
        )}
      </div>
    )
  } else {
    asset = image && (
      <ImageWithPlaceHolder layout="fill" objectFit="contain" {...image} />
    )
  }
  return (
    <div
      className={cx(css.BoxColumnImageText, className, {
        isReversed: reversed,
        isHorizontal: horizontal,
      })}>
      <div className={css.content}>
        <div className={css.imageWrapper}>
          {asset && <Ratio ratio={500 / 245}>{(cn) => asset}</Ratio>}
        </div>
        <div className={css.contentWrapper}>
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
          <div className={cx(css.ctas)}>
            {primaryCta && <Cta className={css.cta} {...primaryCta} />}
            {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
          </div>
        </div>
      </div>
    </div>
  )
}

BoxColumnImageText.defaultProps = {}

export default BoxColumnImageText
